export const RouterConstants = {
    default: '',
    auth: 'auth',
    client: 'client',
    login: 'login',
    signup: 'signup',
    layoutContainer: 'cafeteria',
    resetpasswordsuccess: 'resetpasswordsuccess',
    resetPassword: 'reset-password',
    passwordsuccess: 'passwordsuccess',
    userProfile: {
        default: '',
        baseUrl: 'user',
        myProfile: 'my-profile',
        changePassword: 'change-password'
    },
    settings: {
        baseUrl: 'settings',
        company: 'company',
        location: 'location',
        site: 'site',
        cafeteria: 'cafeteria-setup',
        foodType: 'food-type-setup',
        cafeMenuMappping: 'cafe-menu-mapping',
        mealType: 'meal-type',
        categories: 'categories',
        menuItem: 'menu',
        cafeMenuDiscount: 'cafe-menu-discount',
        cafeMenuTimeSlot: 'cafe-menu-timeslot',
        cafeSpecialOffer: 'cafe-special-offer'

    },
    configurations: {
        baseUrl: 'configurations',
        roleAuthorization: 'role-authorization',
        autherizationMenu: 'authorization-menu',

    },
    dashboard: {
        baseUrl: 'dashboard',
    },
    operations: {
        baseUrl: 'operation',
        vendor: 'vendor',
        user: 'user',
    },
    reports: {
        baseUrl: 'reports',
        bookingReport: 'booking',
        menuUtilization: 'menu-utilization',
        vendorRevenue: 'vendor-revenue',
        vendorSales: 'vendor-sales',
        orderAccuracy: 'order-accuracy',
        customerRatingsByVender: 'customer-ratings-by-vendor',
        userRatingAndFeedback: 'user-rating-and-feedback',
        vendorRanking: 'vendor-ranking',
        mealServed: 'meals-served',
        orderDetails: 'order-details',
    }
}